import { TimeSlot } from '@model';

export function isTimeSlot(value: unknown): value is TimeSlot {
  return (
    typeof value === 'object' &&
    value !== null &&
    'from' in value &&
    typeof (value as TimeSlot).from === 'string' &&
    'to' in value &&
    typeof (value as TimeSlot).to === 'string'
  );
}
